import axios from '../../../config/axiosConfig';
import { NavigateFunction } from 'react-router';

/**
 * Makes a post req to validate encrypted value, then navigates to the homepage based on the corresponding result
 * @param params - should be an object shaped like: {e: string}
 * @param navigate - navigate function that routes
 */
export const validateResetPassword = async (queryValue: string, navigate: NavigateFunction): Promise<void> => {
  const e = queryValue;
  const response = await axios.post<boolean>('api/acctservices/validateResetPassword', {e})
    .then( res => res.data)
    .catch( () => false);

  const state = {
    e: response ? e : '',
    isValid: response
  };

  navigate('/', {state});
};